<!-- BEGIN: Brand -->
<div class="kt-aside__brand kt-grid__item">
    <div class="kt-aside__brand-logo" style="margin: 0 auto;padding-top: 23px;" [hidden]="loading">
        <a  >
            <!-- <img *ngIf="!appSession.tenant || !appSession.tenant.logoId" [src]="defaultLogo" alt="logo" height="38" class="" /> -->
            <img *ngIf="!tenantLogo" [src]="defaultLogo" alt="logo" height="38" class="rounded-circle" />

            <!-- <img *ngIf="appSession.tenant && appSession.tenant.logoId" [src]="remoteServiceBaseUrl + '/TenantCustomization/GetTenantLogo?skin=' + currentTheme.baseSettings.menu.asideSkin + '&tenantId=' + appSession.tenant.id + '&id=' + appSession.tenant.logoId" alt="logo" height="38" class="" /> -->
            <img *ngIf="tenantLogo" [src]="tenantLogo" alt="logo" (error)="handleFailedImage($event)"  class="logoTanant rounded-circle" />

        </a>
    </div>

    <div class="kt-aside__brand-tools">
        <button class="kt-aside__brand-aside-toggler" id="kt_aside_toggler" *ngIf="currentTheme.baseSettings.menu.allowAsideMinimizing" (click)="toggleLeftAside()">
            <span>
           
                <img src="../../../assets/landingPage/Header_Side Menu_Btn.png" alt="logo" class="logoTanant" style="width: 36px;
height: 36px; transform: rotate(180deg);
position: absolute;
    right: 0px;
    top: 0px;
">  
            </span>
          <span>
          
                <img src="../../../assets/landingPage/Header_Side Menu_Btn.png" alt="logo" class="logoTanant" style="width: 36px;
height: 36px;">
            </span> 
        </button>
    </div>
</div>
<!-- END: Brand -->
